var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React, { useEffect, useState } from 'react';
import { MdNavigateBefore, MdNavigateNext } from 'react-icons/md';
import { range } from "../../utils";
import { PaginationButtonWrapper, PaginationButton } from './BaseToggleGroup';
import { getTotalPages } from './utils';
var LEFT_ARROW = 'LEFT';
var RIGHT_ARROW = 'RIGHT';
/**
 * Let's say we have 10 pages and we set adjacentPages to 2
 * Given that the current page is 6
 * The pagination control will look like the following:
 *
 * (1) < {4 5} [6] {7 8} > (10)
 */
export var Paginator = function (_a) {
    var _b = _a.pageSize, pageSize = _b === void 0 ? 20 : _b, _c = _a.page, page = _c === void 0 ? 1 : _c, _d = _a.adjacentPages, adjacentPages = _d === void 0 ? 2 : _d, _e = _a.total, total = _e === void 0 ? 0 : _e, onChange = _a.onChange, id = _a.id;
    var _f = __read(useState(0), 2), sizePage = _f[0], setSizePage = _f[1];
    useEffect(function () {
        setSizePage(window.outerWidth);
    }, [window]);
    var getPaginationControls = function (totalPages, adjacentPages, page) {
        var leftAndRightArrowButtons = 2;
        var totalPageSelectorButtonsToShow = adjacentPages * 2 + 3;
        var totalControlButtonsToShow = totalPageSelectorButtonsToShow + leftAndRightArrowButtons;
        if (totalPages <= totalControlButtonsToShow) {
            return range(1, totalPages + 1);
        }
        var firstCorePage = Math.max(2, page - adjacentPages);
        var lastCorePage = Math.min(totalPages - 1, page + adjacentPages);
        var corePages = range(firstCorePage, lastCorePage + 1);
        var pages = corePages;
        var hasHiddenPagesToLeft = firstCorePage > 2;
        var hasHiddenPagesToRight = totalPages - lastCorePage > 1;
        var isRightEnd = !hasHiddenPagesToRight;
        var totalHiddenPages = totalPageSelectorButtonsToShow - (corePages.length + 1);
        if (hasHiddenPagesToLeft) {
            // handle: (1) < {5 6} [7] {8 9} (10)
            if (isRightEnd) {
                // (1) < ((494 495 496)) {{497 498}} [499] {{500}}
                var extraPagesBeforeCore = range(firstCorePage - totalHiddenPages, firstCorePage);
                pages = __spread([LEFT_ARROW], extraPagesBeforeCore, corePages);
            }
            else {
                // handle: (1) < {4 5} [6] {7 8} > (10)
                pages = __spread([LEFT_ARROW], corePages, [RIGHT_ARROW]);
            }
        }
        else {
            if (hasHiddenPagesToRight) {
                // handle: (1) {2 3} [4] {5 6} > (10)
                var extraPagesAfterCore = range(lastCorePage + 1, lastCorePage + totalHiddenPages + 1);
                pages = __spread(corePages, extraPagesAfterCore, [RIGHT_ARROW]);
            }
        }
        return __spread([1], pages, [totalPages]);
    };
    var gotoPage = function (page) {
        if (onChange) {
            onChange({ page: page });
        }
    };
    var handleClickNextPage = function () {
        gotoPage(page + 1);
    };
    var handleClickPreviousPage = function () {
        gotoPage(page - 1);
    };
    var renderBlocks = function (controls, currentPage, totalPages) {
        return controls.map(function (control) {
            var key = "pagination-item-" + control;
            var buttonProps = {};
            if (control === LEFT_ARROW) {
                buttonProps = {
                    id: id ? id + "-previous-page" : undefined,
                    'aria-label': 'Previous Page',
                    isBordered: true,
                    disabled: page <= 1,
                    onClick: handleClickPreviousPage,
                    children: React.createElement(MdNavigateBefore, null)
                };
            }
            else if (control === RIGHT_ARROW) {
                buttonProps = {
                    id: id ? id + "-next-page" : undefined,
                    'aria-label': 'Next Page',
                    isBordered: true,
                    disabled: page >= totalPages,
                    onClick: handleClickNextPage,
                    children: React.createElement(MdNavigateNext, null)
                };
            }
            else {
                buttonProps = {
                    id: id ? id + "-page-" + control : undefined,
                    'aria-label': "Page " + control,
                    onClick: function () {
                        gotoPage(control);
                    },
                    children: control
                };
            }
            return (React.createElement(PaginationButton, __assign({ key: key, isActive: control === currentPage }, buttonProps)));
        });
    };
    var renderedAdjacentPages = sizePage <= 480 ? 0 : Math.max(0, Math.min(adjacentPages, 2));
    var totalPages = getTotalPages(total, pageSize);
    if (!total || totalPages === 1) {
        return null;
    }
    var controls = getPaginationControls(totalPages, renderedAdjacentPages, page);
    return (React.createElement(PaginationButtonWrapper, null, renderBlocks(controls, page, totalPages)));
};
//# sourceMappingURL=Paginator.js.map